































































import { Component, Prop, Vue } from 'vue-property-decorator';
import GetUsersMessagesQuery from '@/graphql/queries/getUsersMessages.gql';
import request from '@/graphql/request';
import DatePicker from '@/components/input/DatePicker.vue';
import TagMultiselect from '@/components/input/TagMultiselect';
import FilterResult from '@/components/FilterResult.vue';
import IMessage from '@/interfaces/message';
import IDevice from '@/interfaces/device';
import { IDisplayParams } from '@/interfaces/displayParams';
import { IFilterParams } from '@/interfaces/filterParams';

@Component({
  components: {
    FilterResult,
    DatePicker,
    TagMultiselect,
  },
})
export default class FilterMessages extends Vue {

  public get resultData(): IMessage[] {
    return this.messages
      .filter((m: IMessage) => {
        return (
          this.filterParams.deviceIds.includes(m.device.id) &&
          this.filterParams.startTime < new Date(m.timestamp) &&
          this.filterParams.endTime > new Date(m.timestamp)
        );
      })
      .sort((a: IMessage, b: IMessage) => {
        return (
          new Date(b.timestamp).valueOf() - new Date(a.timestamp).valueOf()
        );
      });
  }
  public devices: IDevice[] = [];
  public commandNames: string[] = [];
  public clearFields: boolean = false;
  public messages: IMessage[] = [];
  public displayParams: IDisplayParams = {
    showDevice: true,
    showFileOnly: false,
    showTime: true,
    showCommands: [],
  };
  public filterParams: IFilterParams = {
    deviceIds: [],
    startTime: new Date(0),
    endTime: new Date(),
  };
  private clickOutside: boolean = true;

  public mounted() {
    request(GetUsersMessagesQuery as any, {})
      .then(({ data }) => {
        this.messages = data.getUsersMessages.nodes;
        this.devices = this.messages
          .map(m => m.device)
          .filter((d, i, arr) => arr.findIndex(item => item.id === d.id) === i);
        this.commandNames = this.messages
          .flatMap(m => m.commands)
          .filter(
            (c, i, arr) => arr.findIndex(item => item.name === c.name) === i
          )
          .flatMap(c => c.name);
      })
      .catch(error => {
        // TODO: Error handling
      });
  }

  public clearAll() {
    this.displayParams = {
      ...this.displayParams,
      showDevice: true,
      showFileOnly: false,
      showTime: true,
      showCommands: [],
    };
    this.filterParams = {
      ...this.displayParams,
      deviceIds: [],
      startTime: new Date(0),
      endTime: new Date(),
    };

    this.clearFields = !this.clearFields;
  }

  public updateDeviceFilter(deviceIds: string[]) {
    this.filterParams = {
      ...this.filterParams,
      deviceIds,
    };
  }

  public updateCommandFilter(commands: string[]) {
    this.displayParams = {
      ...this.displayParams,
      showCommands: commands,
    };
  }

  public updateDateFilter(date: { start: Date; end: Date }) {
    this.filterParams = {
      ...this.filterParams,
      startTime: date.start,
      endTime: date.end,
    };
  }

  public toggleDisplayParam(key: keyof IDisplayParams) {
    this.displayParams = {
      ...this.displayParams,
      [key]: !this.displayParams[key],
    };
  }
}
